import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';

import { throwIfAlreadyLoaded } from './common/module-import-guard';
import { EntityModule } from './entity.module';
import { ServiceModule } from './service.module';
import { GuardModule } from './guard.module';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ControlMessagesModule } from '../shared/modules/control-messages/control-messages.module';
import { ErrorDisplay } from './common/errorDisplay';

const NB_CORE_PROVIDERS = [...EntityModule.forRoot().providers, ...ServiceModule.forRoot().providers, ...GuardModule.forRoot().providers];

@NgModule({
  imports: [CommonModule, BrowserModule, HttpClientModule, FormsModule, ReactiveFormsModule, ControlMessagesModule],
  exports: [],
  declarations: [ErrorDisplay]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: CoreModule,
      providers: [...NB_CORE_PROVIDERS]
    };
  }
}
